import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    cname: null,
    dns: null,
    helpLink: null,
    helpText: null,
    landing_page: null,
    favicon: null
};

const cnameSlice = createSlice({
    name: "cname",
    initialState,
    reducers: {
        fillCname(state, action) {
            state.cname = action.payload.cname;
            state.dns = action.payload.dns;
            state.helpLink = action.payload.helpLink;
            state.helpText = action.payload.helpText;
            state.landing_page = action.payload.landing_page;
            state.favicon = action.payload.favicon;
        },
        updateFavicon(state, action) {
            state.favicon = action.payload.favicon;
        }
    }
})

export const { fillCname, updateFavicon } = cnameSlice.actions;
export default cnameSlice.reducer;